import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Cascader, Input, Segmented } from 'antd';
import './collectionToorBar.css';

const CollectionToolbar = ({
  filterOptions,
  appliedFilters,
  onChangeFilter,
  onApplyFilters,
  mobileNumber,
  onSearchCustomer,
  onChangeNumberSearch,
  sortSelector,
  setSortSelector,
  totalEntries,
  tableLoader,
  filterCascader,
}) => {
  return (
    <>
      {/* Top row */}
      <div className="col-toolbar-top-row">
        <div className="col-toolbar-left">
          <Cascader
            className="col-toolbar-cascader"
            value={appliedFilters}
            options={filterOptions}
            onChange={onChangeFilter}
            multiple
            disabled={tableLoader}
            showCheckedStrategy={Cascader.SHOW_CHILD}
            showSearch={{ filter: filterCascader }}
            placeholder="Filter by"
          />

          <Button type="primary" onClick={onApplyFilters} disabled={tableLoader}>
            Apply
          </Button>
        </div>

        <Input.Search
          disabled={tableLoader}
          allowClear
          placeholder="enter phone number"
          enterButton
          className="col-toolbar-search"
          value={mobileNumber}
          onSearch={onSearchCustomer}
          onChange={(e) => onChangeNumberSearch(e.target.value)}
        />
      </div>

      {/* Bottom row */}
      <div className="col-toolbar-bottom-row">
        <div>
          <span className="col-toolbar-sort-label">Sort by Paid At</span>

          <Segmented
            disabled={tableLoader}
            options={['oldest first', 'newest first']}
            value={sortSelector}
            onChange={setSortSelector}
          />
        </div>

        <div className="col-toolbar-info">
          <div className="col-toolbar-entry-count">
            ( showing {totalEntries ? totalEntries.toLocaleString('en-IN') : 0} entries )
          </div>
          <InfoCircleOutlined className="col-toolbar-info-icon" />
        </div>
      </div>
    </>
  );
};

export default CollectionToolbar;
